import { ataService } from '@/services/ata/ata-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { models } from 'cesg-shared';
import { toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaDetailsMutation = (
  projectId: MaybeRefOrGetter<string>,
  ataId: MaybeRefOrGetter<string>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: models.UpCreateAtaBody) =>
      toValue(ataId) === '0'
        ? ataService.post(body)
        : ataService.put(toValue(ataId), body),
    onSuccess: async () => {
      const id = toValue(projectId);
      const currentAtaId = toValue(ataId);

      await queryClient.invalidateQueries({
        queryKey: projectKeys.ataDetail({ projectId: id, ataId: currentAtaId }),
      });
      await queryClient.invalidateQueries({
        queryKey: projectKeys.all({ projectId: id }),
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
